export const SESSION_PRESENCE_STORAGE_KEY = 'authSessionPresent'
export const SESSION_EXPIRY_STORAGE_KEY = 'authSessionExpiresAt'
export const LEGACY_SESSION_ID_STORAGE_KEY = 'authSessionId'
export const AUTH_SESSION_UPDATED_EVENT = 'tl-auth-session-updated'

export const parseExpiryTimestamp = (value?: string | null): number | null => {
  if (!value) return null

  const parsed = Date.parse(value)
  if (Number.isNaN(parsed) || parsed <= 0) {
    return null
  }

  return parsed
}

const clearStoredAuthSessionPresenceState = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.removeItem(SESSION_PRESENCE_STORAGE_KEY)
  window.localStorage.removeItem(SESSION_EXPIRY_STORAGE_KEY)
  window.localStorage.removeItem(LEGACY_SESSION_ID_STORAGE_KEY)
}

export const isAuthSessionStorageKey = (key: string | null) =>
  key === SESSION_PRESENCE_STORAGE_KEY
  || key === SESSION_EXPIRY_STORAGE_KEY
  || key === LEGACY_SESSION_ID_STORAGE_KEY

export const notifyAuthSessionUpdated = () => {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new Event(AUTH_SESSION_UPDATED_EVENT))
}

export const storeAuthSessionPresence = (expiresAt?: string | null) => {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(SESSION_PRESENCE_STORAGE_KEY, '1')
  window.localStorage.removeItem(LEGACY_SESSION_ID_STORAGE_KEY)

  if (expiresAt) {
    window.localStorage.setItem(SESSION_EXPIRY_STORAGE_KEY, expiresAt)
  } else {
    window.localStorage.removeItem(SESSION_EXPIRY_STORAGE_KEY)
  }

  notifyAuthSessionUpdated()
}

export const clearStoredAuthSessionPresence = () => {
  clearStoredAuthSessionPresenceState()
  notifyAuthSessionUpdated()
}

export const readStoredAuthSessionPresence = () => {
  if (typeof window === 'undefined') {
    return false
  }

  const sessionPresent = window.localStorage.getItem(SESSION_PRESENCE_STORAGE_KEY)
    || window.localStorage.getItem(LEGACY_SESSION_ID_STORAGE_KEY)

  if (!sessionPresent) {
    return false
  }

  const expiresAt = window.localStorage.getItem(SESSION_EXPIRY_STORAGE_KEY)
  const parsedExpiry = parseExpiryTimestamp(expiresAt)

  if (parsedExpiry !== null && parsedExpiry <= Date.now()) {
    clearStoredAuthSessionPresenceState()
    return false
  }

  if (!window.localStorage.getItem(SESSION_PRESENCE_STORAGE_KEY)) {
    window.localStorage.setItem(SESSION_PRESENCE_STORAGE_KEY, '1')
    window.localStorage.removeItem(LEGACY_SESSION_ID_STORAGE_KEY)
  }

  return true
}
